import {isFeatureEnabled} from 'feature-flags';
import {Card} from 'platform/components';
import {Box, VStack} from 'platform/foundation';
import {match} from 'ts-pattern';

import {useCallback} from 'react';

import {mergeAll} from 'ramda';

import {EntityResourceIds} from '@dms/api/shared';
import {featureFlags} from '@dms/feature-flags';
import i18n from '@dms/i18n';
import {DmsDataGrid, type DmsDataGridProps, openActivityChangeLog} from '@dms/shared';

import {useRequiredParams} from 'shared/web';

import type {ActionCallback, QueryFilterObject} from 'features/eag-grid';

const PREDEFINED_COLUMNS = ['commandId'] as const;

export function CustomerActivityLogs(props: Pick<DmsDataGridProps, 'maximization'>) {
  const {id} = useRequiredParams();

  const activityLogQueryModifier = useCallback(
    (filter: QueryFilterObject) => mergeAll([filter, {record: id}]),
    [id]
  );

  const actionCallback: ActionCallback<typeof PREDEFINED_COLUMNS> = (data) => {
    const {actionKey, getColumnData} = data;
    const commandId = getColumnData('commandId')?.value;

    match(actionKey).with('detail', () => {
      if (commandId && typeof commandId === 'string') {
        openActivityChangeLog({resourceId: EntityResourceIds.customer, commandId, recordId: id});
      } else {
        console.error('no command in row');
      }
    });
  };

  return (
    <Box flex={1} minWidth={0}>
      <VStack spacing={4}>
        <Card title={i18n.t('general.labels.activityLogs')}>
          <Box>
            <DmsDataGrid
              maximization={props.maximization}
              actionCallback={actionCallback}
              predefinedColumns={PREDEFINED_COLUMNS}
              gridCode={
                isFeatureEnabled(featureFlags.SALES_ACTION_LOG_CUSTOMER)
                  ? 'customer-audit-log'
                  : 'customer-action-log'
              }
              autoHeight
              queryModifier={activityLogQueryModifier}
              data-testid="activity-logs-datagrid"
            />
          </Box>
        </Card>
      </VStack>
    </Box>
  );
}
